<template>
  <vs-popup title="Select type to create" :active.sync="showPrompt">
    <vs-row>
      <vs-col vs-type="flex" vs-justify="center" class="p-5" vs-w="12">
        <vs-button
          @click.native="onSelect(0)"
          color="primary"
          type="filled"
          icon="add"
        >
          Activity
        </vs-button>
        <vs-button
          @click.native="onSelect(1)"
          color="primary"
          type="filled"
          icon="add"
          class="ml-5"
        >
          Social
        </vs-button>
        <vs-button
          @click.native="onSelect(2)"
          color="primary"
          type="filled"
          icon="add"
          class="ml-5"
        >
          Paid Media
        </vs-button>
      </vs-col>
    </vs-row>
  </vs-popup>
</template>

<script>
export default {
  data() {
    return {
      showPrompt: false,
      dates: null,
    };
  },
  methods: {
    show(dates) {
      this.dates = dates;
      this.showPrompt = true;
    },
    onSelect(type) {
      this.$emit("onSelected", type, this.dates);
      this.showPrompt = false;
    },
  },
};
</script>

<style lang="scss">
.con-vs-dialog .vs-dialog {
  max-width: 600px;
}
.vs-select--label {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6) !important;
}
</style>
